import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import ReactQuill from "react-quill";
import api from "../../api";
import Logo from "../../images/logo-2.png";
import add from "../../images/add.png";
import "react-quill/dist/quill.snow.css";
import { useSelector } from "react-redux";

export function AddTemplateModal({ getTemplate, setShow, allCategory }) {
  const adminStore = useSelector((state) => state.adminReducer);
  const [loader, setLoader] = useState(false);

  const [inputData, setInputData] = useState({
    description: "",
    title: "",
  });

  const handleSubmit = async () => {
    try {
      if (inputData?.description && inputData?.title && inputData.category) {
        setLoader(true);
        let payload = {
          _id: adminStore.admin.admin._id,
          title: inputData.title,
          template: inputData.description,
          category: inputData.category || "",
        };
        const signalResponse = await api.addTemplate(payload);
        // console.log(signalResponse);
        if (signalResponse?.success) {
          alert("Template added successfully");
          setInputData({
            description: "",
            title: "",
          });
          setLoader(false);
          getTemplate();
          setShow(false);
          // sendNotification()
        } else {
          setLoader(false);
          alert("Something went wrong");
        }
      } else {
        setLoader(false);
        alert("Please insert all fields");
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
      alert("Something went wrong");
    }
  };

  var Editor = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image", "video"],
      ["clean"],
    ],
    clipboard: {
      // toggle to add extra line breaks when pasting HTML:
      matchVisual: false,
    },
  };

  const handleChange = (e) => {
    // console.log(e);
    setInputData({ ...inputData, description: e });
  };

  return (
    <>
      {/* Begin Page Content */}
      <div className="container-fluid">
        {/* Content Row */}
        <div className="row">
          {/* Area Chart */}
          <div className="col">
            <div className="row mx-0 drivers-row">
              <div className="col-xl-6 col-md-7  d-flex justify-content-between pr-0">
                <h4 className="color-dark fs-17 dib font-weight-bold mr-5">
                  Add Template
                </h4>
              </div>
            </div>
            <div className="card sortby-box br-10 border-transparent mt-3">
              <div className="card-header br-10  bg-white border-transparent py-3 ">
                {/* <div className="form-group mb-3">
                                <input type="text" className='form-control' onChange={(e)=>setTitle(e.target.value)} placeholder='Title...' />
                              </div> */}
                <div className="form-group my-3">
                  <input
                    type="text"
                    value={inputData?.title}
                    onChange={(e) =>
                      setInputData({
                        ...inputData,
                        title: e.target.value,
                      })
                    }
                    className="form-control"
                    placeholder="Add Title..."
                  />
                </div>
                <div className="form-group my-3 me-3 position-relative">
                  <i className="fa-solid fa-caret-down  arrowDownIco" />

                  <select
                    name="category"
                    id=""
                    onChange={(e) =>
                      setInputData({
                        ...inputData,
                        category: e.target.value,
                      })
                    }
                    value={inputData?.category}
                    className="form-control ng-dirty ng-invalid ng-touched"
                  >
                    <option value="">Select Category</option>
                    {allCategory.map((val, key) => (
                      <option value={val?._id}>{val?.name}</option>
                    ))}
                  </select>
                </div>
                <div className="descMainPost">
                  <ReactQuill
                    placeholder="Add description..."
                    modules={Editor}
                    theme="snow"
                    value={inputData.description}
                    onChange={handleChange}
                  />
                </div>

                <div className="sendMailBtn mt-3">
                  <button onClick={handleSubmit} className="btn-dark">
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /.container-fluid */}
      {loader && (
        <div className="seekoLoader">
          <div className="loader">
            <img src={Logo} alt="loader" />
          </div>
        </div>
      )}
    </>
  );
}
